import { useState } from "react";
import styles from "./styles.module.css";
import Container from "../Container";
import Button from "../Button";
import ArrowLink from "../ArrowLink";
import Heading from "../Heading";
import Image from "next/image";
import Link from "next/link";
import { Search, ChevronRight } from "../Icons";
import cn from "classnames";

const ResourcesPagination = ({ pages, activePage, onClick }) => {
  return (
    <div className={styles.resourcesPagination}>
      <div className={styles.prevWrapper}>
        {activePage !== 1 && (
          <Link scroll={false} passHref href={`?page=${activePage - 1}`}>
            <a className={styles.prev}>
              <ChevronRight fill="var(--green)" />
              Prev
            </a>
          </Link>
        )}
      </div>
      {pages > 12 ? (
        <>
          {[...Array(pages).keys()].slice(0, 4).map((item, index) => {
            return (
              <Link scroll={false} passHref href={`?page=${item + 1}`} key={index}>
                <a
                  key={item}
                  className={cn(styles.page, {
                    [styles.pageActive]: activePage === item + 1,
                  })}
                >
                  {item + 1}
                </a>
              </Link>
            );
          })}
          <span className={styles.page}>...</span>
          {[...Array(pages).keys()].slice(-4).map((item, index) => {
            return (
              <Link scroll={false} passHref href={`?page=${item + 1}`} key={index}>
                <a
                  key={item}
                  className={cn(styles.page, {
                    [styles.pageActive]: activePage === item + 1,
                  })}
                >
                  {item + 1}
                </a>
              </Link>
            );
          })}
        </>
      ) : (
        [...Array(pages).keys()].map((item, index) => {
          return (
            <Link scroll={false} passHref href={`?page=${item + 1}`} key={index}>
              <a
                key={item}
                className={cn(styles.page, {
                  [styles.pageActive]: activePage === item + 1,
                })}
              >
                {item + 1}
              </a>
            </Link>
          );
        })
      )}
      <div className={styles.nextWrapper}>
        {activePage < pages && (
          <Link scroll={false} passHref href={`?page=${activePage + 1}`}>
            <a className={styles.next}>
              Next <ChevronRight fill="var(--green)" />
            </a>
          </Link>
        )}
      </div>
    </div>
  );
};

export default ResourcesPagination;
